/** Tabellen-Lesen (get_table_rows) */
export const CONTRACT = "nftrewards";
/** Admin-Transaktionen (setpool, setsurvey, …) */
export const TX_CONTRACT = "nftreward";

export const DEFAULT_RPC = (() => {
  try {
    // Prefer VITE_RPC_ENDPOINT (legacy naming) and fall back to CRA-style REACT_APP_RPC_ENDPOINT.
    // eslint-disable-next-line no-undef
    const env = (typeof process !== "undefined" && process?.env)
      ? (process.env.VITE_RPC_ENDPOINT || process.env.REACT_APP_RPC_ENDPOINT || process.env.REACT_APP_RPC || "")
      : "";
    const v = String(env || "").trim();
    return v || "https://xpr-mainnet-api.bloxprod.io";
  } catch {
    return "https://xpr-mainnet-api.bloxprod.io";
  }
})();

export const FALLBACK_RPCS = [
  "https://api.protonnz.com",
  "https://proton-public.neftyblocks.com",
  "https://proton.cryptolions.io",
];

export const LS_OPEN_CARDS_KEY = "nr_openCards_v1";
export const LS_TIPS_KEY = "nr_tips_v1";
export const LS_ADMIN_UI_MODE_KEY = "nr_admin_ui_mode_v1";
/** Contract wallet: optional { projectId, account } to mirror a project allowed account in the UI */
export const LS_CONTRACT_VIEW_AS_KEY = "nr_contract_view_as_v1";

export const APP_NAME = "NFT Claim Hub";
